import { render } from "./DocumentRow.vue?vue&type=template&id=4cfd27f8&scoped=true&ts=true"
import script from "./DocumentRow.vue?vue&type=script&lang=ts"
export * from "./DocumentRow.vue?vue&type=script&lang=ts"

import "./DocumentRow.vue?vue&type=style&index=0&id=4cfd27f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfd27f8"]])

export default __exports__